<script lang="ts">
  import clsx from 'clsx'

  import withPreventDefault from '../../../../utils/withPreventDefault'
  import CheckedIcon from '../../icons/CheckedIcon.svelte'

  type Props = {
    hidden?: boolean
    checked: boolean
    label: string
    onclick: () => void
  }

  const { checked, label, onclick, hidden = false }: Props = $props()

  const onClick = (e: MouseEvent) =>
    withPreventDefault(e, () => {
      onclick()
    })
</script>

<li class="pl-3 w-full">
  <button
    class={clsx(
      'flex items-center justify-start gap-2 w-full',
      hidden ? 'hidden' : 'flex',
    )}
    onclick={(e) => onClick(e)}
  >
    <span class={clsx('h-8 w-6', !checked && 'opacity-20')}
      ><CheckedIcon /></span
    >
    <span class={clsx(checked && 'font-semibold')}>{label}</span>
  </button>
</li>
